<template>
    <div>
        <main class="authentication">
            <div class="authentication__content">
                <div class="authentication__form authentication__form--login">
                    <h1 class="authentication__form-title">{{ trans('page.password-reset.title') }}</h1>
                    <password-reset @submit="resetPassword" />
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import { apiMixin } from 'relapp-api';
import { pageLoadingStatusMixin } from 'relapp-loading';
import { mapGetters } from 'vuex';
import { PasswordReset, AuthApi } from 'relapp-auth';
import { EventBus } from 'relapp-event';

export default {
    components: {
        PasswordReset
    },
    mixins: [apiMixin, pageLoadingStatusMixin],

    props: {
        token: {
            type: String,
            required: false
        }
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        this.finishLoading();
        if (this.isLoggedIn) {
            this.$router.push({ name: 'orderFullDomain' });
        }
    },
    computed: {
        ...mapGetters({
            isLoggedIn: 'user/isLoggedIn'
        })
    },
    methods: {
        /**
         * Call the endpoint to reset the password for an email.
         *
         * @param {object} form
         */
        resetPassword(form) {
            this.startLoading();
            AuthApi.resetPasswordEmail(form)
                .then(() => {
                    this.finishLoading();

                    EventBus.$emit('notification', {
                        type: 'success',
                        message: trans('authentication.password-reset.confirmation.message')
                    });
                })
                .catch(this.handleError)
                .then(this.finishLoading);
        }
    },
    metaInfo: {
        title: trans('page.password-reset.title')
    }
};
</script>
